<template>
  <viewer
    :options="options"
    :images="images"
    @inited="inited"
    ref="viewer"
    :class="{ [containerClassName]: !!containerClassName }"
  >
    <template slot-scope="scope">
      <div 
        v-for="({ source, thumbnail }, index) in scope.images"
        :key="index"
        :class="{ [itemClassName]: !!itemClassName }" 
      >
        <img 
          v-if="!getUnpaid" 
          :class="{ [imgClassName]: !!imgClassName }"  
          :src="thumbnail" 
          :data-source="source"
        />
        <HMTImageWatermark 
          v-else 
          :src="thumbnail" 
          :class="{ [imgClassName]: !!imgClassName }"
        />
        <slot />
      </div>
    </template>
  </viewer>
</template>

<script>
  import { mapGetters } from 'vuex';
  import Vue from 'vue'
  import VueViewer from 'v-viewer'

  import 'viewerjs/dist/viewer.css'

  import HMTImageWatermark from '@/shared/components/ImageWatermark'

  Vue.use(VueViewer)

  export default {
    name: 'HMTViewer',
    components: {
      HMTImageWatermark
    },
    props: {
      items: {
        type: Array
      },
      mapper: {
        type: Function
      },
      containerClassName: {
				default: '',
				type: String
			},
      itemClassName: {
				default: '',
				type: String
			},
      imgClassName: {
				default: '',
				type: String
			}
    },
    data () {
      return {
        options: {
          url: 'data-source',
          zIndex: 9999
        }
      }
    },
    computed: {
      ...mapGetters('tour', ['getUnpaid']),
      images () {
        if (this.mapper) {
          return this.items.map(this.mapper);
        }

        return this.items.map(item => ({
          thumbnail: item.xl,
          source: item.original
        }));
      }
    },
    methods: {
      inited (viewer) {
        this.$viewer = viewer;
      }
    }
  };
</script>
